import { createPortal } from 'react-dom';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';
import { Calendar, Clock } from 'react-bootstrap-icons';

const DatePickerPortalContainer = ({ children }) => {
  if (typeof document === 'undefined') {
    return children;
  }
  return createPortal(children, document.body);
};

const CareMapprDatePicker = ({
  label,
  selectedDate,
  onChange,
  placeholderText = 'Select a date',
  controlId = 'datePicker',
  className = '',
  minDate,
  maxDate,
  disabled = false,
  mode = 'date',
}) => {
  const icon =
    mode === 'date' ? (
      <Calendar
        className="position-absolute"
        style={{
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />
    ) : (
      <Clock
        className="position-absolute"
        style={{
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />
    );

  return (
    <Form.Group controlId={controlId} className={`${className}`}>
      {label && <Form.Label className="ellipsis">{label}</Form.Label>}
      <div className="position-relative">
        <DatePicker
          selected={selectedDate}
          onChange={onChange}
          placeholderText={placeholderText}
          className="form-control"
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          showTimeSelect={mode === 'time'}
          showTimeSelectOnly={mode === 'time'}
          timeIntervals={15}
          dateFormat={mode === 'date' ? 'dd/MM/yyyy' : 'HH:mm'}
          popperContainer={DatePickerPortalContainer}
          popperClassName="caremappr-datepicker-popper"
          popperProps={{ strategy: 'fixed' }}
        />
        {icon}
      </div>
    </Form.Group>
  );
};

export default CareMapprDatePicker;
